import { render, staticRenderFns } from "./oilOrderRecord.vue?vue&type=template&id=9f9439fe&scoped=true"
import script from "./oilOrderRecord.vue?vue&type=script&lang=js"
export * from "./oilOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9439fe",
  null
  
)

export default component.exports